var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center"},[_c('v-chip',{attrs:{"label":"","color":_vm.result === 'REPROVADO' ? 'error' : 'success',"small":""}},[_vm._v(" "+_vm._s(_vm.result)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }